import * as React from 'react';
import { Modal } from 'antd';
import { ModalFuncProps } from 'antd/lib/modal';
import { localizedString } from '@locale/index';

export function discardModal(onCancel?: () => void) {

  Modal.confirm({
    onCancel,
    centered: true,
    width: '60%',
    title: <div>
      {localizedString('common_modal_cancel_confirm_title')}
    </div>,
    icon: null,
    content: <div>
      {localizedString('common_modal_cancel_confirm_content')}
    </div>,
    okText: localizedString('common_modal_cancel_confirm_keeping'),
    cancelText: localizedString('common_modal_cancel_confirm_discard'),
    closable: false
  });
}

export function niConfirm(props: ModalFuncProps) {

  const ps = {
    width: '60%',
    ...props,
    className: 'ni-modal ' + props.className,
    icon: null,
    closable: false,
    title: props.icon ? <div>{props.icon}{props.title}</div> : props.title
  };

  if (ps.onOk) {
    return Modal.confirm(ps);
  }

  return Modal.error(ps);
}
